export const common = {
  classes: 'inline transition-all duration-300',
  styles: {},
};
